import { render } from "./InitialLoading.vue?vue&type=template&id=78346277&scoped=true"
import script from "./InitialLoading.vue?vue&type=script&lang=js"
export * from "./InitialLoading.vue?vue&type=script&lang=js"

import "./InitialLoading.vue?vue&type=style&index=0&id=78346277&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78346277"]])

export default __exports__